export default __webpack_public_path__ + "static/media/fireFlame.716b81f8.svg";